import React from "react"
import { Alert } from "../../.."
import { store } from "../../../stores/Store"
import AutomationConfirmFormSection from "./AutomationConfirmFormSection"
import AutomationQuestionnaireSelectFormSection from "./AutomationQuestionnaireSection"
import AutomationOptions from "../../views/main/detail/automation/AutomationOptions"


export default function AutomationRunForm ({
    automationOptions,
    automationNodeUid,
    enquiry = null 
}) {

    const [automationOption, setAutomationOption] = React.useState(null)
    const [automationData, setAutomationData] = React.useState(null)

    const submit = async (values) => {
        
        var automationDataToSend = {...automationData, ...values}
        setAutomationData(automationDataToSend)

        await store.AutomationStore.run(JSON.stringify(automationDataToSend), automationOption.id, automationNodeUid).then(() => {
            store.AlertStore.Close()
        }).catch(() => {
            Alert({message: "Failed to run automation"})
        })
    }

    var dataSourcesLength = automationData?.questionnaires?.length ? automationData.questionnaires.length : 0
    if (enquiry) {
        dataSourcesLength += 1
    }

    return (
        <div style={{width: "80vw", maxWidth: !!automationOption ? "700px" : "500px"}}>
            <div style={{display: "flex", justifyContent: "space-between", gap: "8px"}}>
                <h2>Create Automation</h2>
                {automationOption ? <small style={{color: "grey", fontWeight: 400}}>{automationOption.label}</small> : null}
            </div>

            <AutomationOptions 
                hidden={!!automationOption} 
                automationOptions={automationOptions}
                onSubmit={(ao) => setAutomationOption(ao)} />

            <AutomationQuestionnaireSelectFormSection
                hidden={automationData || !automationOption}
                enquiry={enquiry}
                automationOption={automationOption}
                onCancel={() => {
                    setAutomationOption(null)
                    setAutomationData(null)
                }}
                onSubmit={(data) => setAutomationData(data)} />

            <AutomationConfirmFormSection
                hidden={!automationData}
                automationData={automationData}
                automationOption={automationOption}
                onCancel={() => setAutomationData(null)}
                onSubmit={async (data) => await submit(data)} />
        </div>
    )
}